import { render, staticRenderFns } from "./QueryPageRedirect.vue?vue&type=template&id=2acbab3b&"
import script from "./QueryPageRedirect.vue?vue&type=script&lang=js&"
export * from "./QueryPageRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports